<template>
  <div>
    <div class="display-1 font-weight-bold pa-3 ">
      <div class="px-sm-4 pt-sm-4 px-1 pt-4 pb-2">Смена тарифа СМС</div>
    </div>
    <div class="subtitle-2 font-weight-medium px-3 ml-sm-4 ml-1">
      <div>Переход на новый тариф произойдет с {{ dateRefTariff }}</div>
      <div>При превышении лимита все последующие СМС по 2,50 /шт.</div>
    </div>
    <div class="pt-0 px-0">
      <v-layout
        wrap
        :class="
          `${isMobole ? 'list-vertical-border' : 'list-horizontal-border'}`
        "
        class="pt-sm-3 pt-4"
        style="margin-right: -20px;`
        "
      >
        <v-flex
          v-for="tariff in $store.getters.tariffList"
          :key="tariff.id"
          :class="`${isMobole ? 'xs12' : ''}`"
          class="border-block pb-sm-2"
        >
          <v-layout
            ma-0
            :class="
              `${
                isMobole
                  ? 'd-flex align-start'
                  : 'column justify-space-between align-center text-sm-center'
              }`
            "
            class="pl-3 pr-4 flex-column fill-height"
          >
            <div class="xs6 pb-2 pb-sm-0 layout column justify-space-between">
              <div
                class="flex text-sm-center display-1 font-weight-bold pb-3 mb-sm-3 pt-4 mt-sm-3 mt-2 ml-sm-0 ml-1"
                style="max-width: 120px;"
              >
                {{ tariff.name }}
              </div>
              <div class="font-weight-medium pb-sm-3 mb-sm-1 pb-2 ml-sm-0 ml-1">
                {{ tariff.smsCount }}
              </div>
              <div class="font-weight-medium pb-3 mb-sm-1 ml-sm-0 ml-1">
                {{
                  `${tariff.functions.length > 1 ? "от " : ""} ${
                    tariff.price
                  } ₽/мес`
                }}
              </div>
            </div>
            <div
              :class="`${isMobole ? 'align-self-end' : ''}`"
              class="pt-3 mb-sm-0 pb-sm-4 xs6 pb-3 mb-2 text-xs-right"
            >
              <v-btn
                class="primary btn-tariff"
                :disabled="param.tarif_id === tariff.id"
                @click="change(tariff.id)"
              >
                {{ param.tarif_id === tariff.id ? "Текущий" : "Выбрать" }}
              </v-btn>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "tariffChange",

  data: () => ({
    error: false,
    dateRefTariff: `${moment()
      .add(1, "day")
      .format("D MMMM YYYY")} года`
  }),
  props: {
    param: {
      type: Object
    }
  },
  computed: {
    isMobole() {
      return ["xs"].includes(this.$vuetify.breakpoint.name);
    }
  },
  beforeMount() {
    this.$store.dispatch("tariffListLoad");
  },
  methods: {
    // переход на следующий шаг (кнопка выбрать)
    change(tarif_id) {
      this.$emit("change", {
        tarif_id: tarif_id,
        service_id: this.param.service_id
      });
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>
